export default "__VITE_ASSET__Ahx9DfAx__"